import { Component, Input } from '@angular/core';
import { ComponentsModule } from '@mastechnicaegroup/carelinelive-ui';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-dashboard-stats-card',
    imports: [
        ComponentsModule,
        RouterLink
    ],
    templateUrl: './dashboard-stats-card.component.html',
    standalone: true,
    styleUrl: './dashboard-stats-card.component.scss'
})
export class DashboardStatsCardComponent {
    @Input() title = '';
    @Input() count = 0;
    @Input() subtitle = '';
    @Input() routerLink: string | null = null;
    @Input() queryParams: Record<string, unknown> | null = null;
}
